import { Component, computed, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { rxResourceFixed } from '@zayan-erp/shared';
import { TemplateDocumentService } from '../../services/template-document.service';
import { DropdownData, LookupsService } from '@zayan-erp/shared';
import { of } from 'rxjs';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'lib-template-variables',
  imports: [FormsModule],
  templateUrl: './template-variables.component.html'
})
export class TemplateVariablesComponent {
  _templateService = inject(TemplateDocumentService);
  _lookupsService = inject(LookupsService);

  selectedVariable = signal<DropdownData | null>(null);
  searchTerm = signal<string>('');

  templateVariables = toSignal(this._lookupsService.readTemplateVariables());

  templateVariablesSets = rxResourceFixed({
    params: () => ({ id: this.selectedVariable()?.id ?? this.templateVariables()?.[0]?.id }),
    defaultValue: [],
    stream: ({ params }) => {
      if (!params?.id) {
        return of([]);
      }
      this.selectedVariable.set(this.templateVariables()?.[0] ?? null);
      return this._templateService.readTemplateVariables(params.id ?? '');
    }
  });

  variables = computed(() => this.templateVariablesSets.value());

  visibleVariables = computed(() =>
    this.variables()?.filter((variable: any) => variable.toLowerCase().includes(this.searchTerm().toLowerCase()))
  );
}
